// extracted by mini-css-extract-plugin
export default {"cards":"Cards_cards__YCpqn","link":"Cards_link__7YA3U","image":"Cards_image__VgEac"};